uvex-button-toggle-offcanvas {
  padding: 1.5rem 0;
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
}
@media (min-width: 992px) {
  uvex-button-toggle-offcanvas {
    display: none;
  }
}
uvex-button-toggle-offcanvas:focus {
  outline: 0;
}
uvex-button-toggle-offcanvas span {
  display: block;
  position: relative;
}
uvex-button-toggle-offcanvas span, uvex-button-toggle-offcanvas span:before, uvex-button-toggle-offcanvas span:after {
  transform: rotate(0deg);
  transition: border 0.25s, transform 0.25s;
  will-change: transform;
  width: 40px;
  height: 2px;
  background-color: #fff;
}
.layout-heckel uvex-button-toggle-offcanvas span, .layout-heckel uvex-button-toggle-offcanvas span:before, .layout-heckel uvex-button-toggle-offcanvas span:after {
  background-color: #000;
}
uvex-button-toggle-offcanvas span:before, uvex-button-toggle-offcanvas span:after {
  content: "";
  position: absolute;
  left: 0;
}
uvex-button-toggle-offcanvas span:before {
  top: -8px;
}
uvex-button-toggle-offcanvas span:after {
  bottom: -8px;
}
uvex-button-toggle-offcanvas.active span {
  background-color: transparent;
}
uvex-button-toggle-offcanvas.active span:before, uvex-button-toggle-offcanvas.active span:after {
  height: 2px;
}
uvex-button-toggle-offcanvas.active span:before {
  top: 0;
  transform: rotate(135deg);
}
uvex-button-toggle-offcanvas.active span:after {
  top: 0;
  transform: rotate(225deg);
}